import React from 'react';

function YoutubeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="none" viewBox="0 0 20 21">
      <path
        fill="#000"
        d="M16.34 6.256c-.064-.249-.244-.436-.45-.494-.365-.102-2.14-.336-5.89-.336-3.75 0-5.523.234-5.89.336-.203.057-.383.244-.448.494-.09.353-.328 1.833-.328 4.17 0 2.337.238 3.817.328 4.172.064.248.244.435.449.492.366.103 2.139.336 5.889.336 3.75 0 5.524-.233 5.89-.335.204-.057.384-.245.448-.494.092-.353.329-1.837.329-4.17 0-2.334-.237-3.817-.328-4.171zm1.613-.415c.381 1.485.381 4.585.381 4.585s0 3.1-.38 4.585c-.212.821-.832 1.467-1.616 1.685-1.424.397-6.338.397-6.338.397s-4.91 0-6.338-.397a2.342 2.342 0 01-1.615-1.685c-.38-1.485-.38-4.585-.38-4.585s0-3.1.38-4.585c.212-.82.831-1.466 1.615-1.685 1.428-.396 6.339-.396 6.339-.396s4.913 0 6.337.396a2.344 2.344 0 011.615 1.685zm-9.619 7.502V7.51l5 2.916-5 2.917z"
      ></path>
    </svg>
  );
}

export default YoutubeIcon;
